import { render, staticRenderFns } from "./mb-business-select.vue?vue&type=template&id=baee8fc8&scoped=true&"
import script from "./mb-business-select.vue?vue&type=script&lang=ts&"
export * from "./mb-business-select.vue?vue&type=script&lang=ts&"
import style0 from "./mb-business-select.vue?vue&type=style&index=0&id=baee8fc8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baee8fc8",
  null
  
)

export default component.exports